export default __webpack_public_path__ + "static/media/Isologo@3x.398981fe.png";